<template>
<div class="clazz_panel after_border" @click="gotoRace">
  <img class="cover" v-lazy="race.cover_url">
  <div class="info">
    <div class="title">{{ race.name }}</div>
    <div class="detail">
      <div style="margin-bottom: 4px;">时间：{{ race.start_time }} ～ {{ race.end_time }}</div>
      <div>赛事距离：{{ distanceList(race.rules) }}</div>
    </div>
  </div>
</div>
</template>

<script>
import { Tag } from 'vant'

export default {
  name: 'RacePanel',
  components: {
    [Tag.name]: Tag
  },
  props: {
    race: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  methods: {
    distanceList (rules) {
      return rules.map((r) => `${r.distance}公里`).join(',')
    },
    gotoRace () {
      this.$router.push('/race/' + this.race.id)
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_panel {
  height: 750px;
  height: 145px;
  padding: 25px 0;
  display: flex;
  .cover {
    width: 220px;
    height: 145px;
    margin-left: 20px;
    object-fit: cover;
  }
  .info {
    // display: flex;
    // flex-direction: column;
    // justify-content: space-around;
    height: 145px;
    margin-left: 20px;
    width: 480px;
    .title {
      font-size: 28px;
      font-weight: bold;
      color: #323233;
    }
    .detail {
      font-size: 24px;
      color: #bbb;
      margin-top: 10px;
    }
  }
}
</style>
